// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2GoC_","itemTitle":"ClientEmergencyInfo_itemTitle__U2ydl","itemText":"ClientEmergencyInfo_itemText__1CZXO"};